import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppDispatch } from "..";
import runningHttpClient from "../../axios";
import { ActivityType, ImagesDomain, NotificationDomain, UserProfileDomain } from "../../models/commonModels";
import { GetProp } from "antd";
import { UploadProps } from "antd/lib";
import { fetchError } from "../app-slice/AppSlice";
import { AxiosError } from "axios";
type FileType = Parameters<GetProp<UploadProps, 'beforeUpload'>>[0];
interface InitSt{
    user:UserProfileDomain|null,
    notification:NotificationDomain[]|null
}

const initSt:InitSt={
    user:null,
    notification:null
}
const ProfileSlie = createSlice({
    name:"ProfileSlie",
    initialState:initSt,
    reducers:{
        fetchUser(state, action:PayloadAction<UserProfileDomain|null>){
            state.user = action.payload;
        },
        fetchNotification(state, action:PayloadAction<NotificationDomain[]|null>){
            state.notification=action.payload;
        }
    }
});

export const {
    fetchUser,
    fetchNotification
}=ProfileSlie.actions;

export default ProfileSlie.reducer;

export const getUserProfile = (uMane:number|null, activity:ActivityType, isFirst:boolean) =>async (dispatch:AppDispatch)=>{
    if(isFirst){
        dispatch(fetchUser(null))
        dispatch(fetchNotification(null))
    }
    try{
        const res = await runningHttpClient.get<UserProfileDomain>('api/v1/user/profile', {params:{u:uMane, a:activity}})
        if(res.status===200){
            dispatch(fetchUser(res.data))
            dispatch(getNotification(uMane))
        }
    }catch(e){
            dispatch(fetchError((e as AxiosError).message))
    }finally{

    }
}

export const changeAvatar = (file:File)=> async (dispatch:AppDispatch)=>{
    try{ 
        const avatarString = await getBase64(file as FileType);
        const newAvatar :ImagesDomain = {image:avatarString.split(',')[1], file_name:file.name}
        const res = await runningHttpClient.post('/api/v1/user/avatar', newAvatar)
    }catch(e){

    }finally{

    }
}

export const getNotification=(uId:number|null)=>async (dispatch:AppDispatch)=>{
    try{
        const res = await runningHttpClient.get('/api/v1/notification',{params:{u:uId}})
        if(res.status===200){
            dispatch(fetchNotification(res.data))
        }
    }catch(e){

    }
}

    const getBase64 = (file: FileType): Promise<string> =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result as string);
            reader.onerror = (error) => reject(error);
        });
